// extracted by mini-css-extract-plugin
module.exports = {"userSelectBox":"functions_userSelectBox__1RRjY","dx-texteditor-input":"functions_dx-texteditor-input__1rJS6"};